import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * O mesmo cadastro atende dois mundos:
 *
 *   - ENSINO do ano letivo — ANO = ano selecionado na barra;
 *   - ENSINO PADRÃO DO HISTÓRICO — ANO = 0.
 *
 * A única diferença é o ano: o ensino do histórico não pertence a nenhum ano letivo, ele existe
 * para o Histórico Escolar poder referenciar um ensino que a escola talvez nem ofereça mais.
 * Toda a validação (séries, conceitos, plano curricular, grade e grade da série) é idêntica —
 * por isso as telas são as mesmas, e o que muda é `meta.ensinoHistorico`.
 */
export default [
  {
    description: 'Tipo de Ensino',
    path: '/academico/parametros/ensino',
    name: 'ensino',
    component: () => import('@/views/academico/parametros/ensino/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.TIPODEENSINONOVO_MENU_300900301],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Tipo de Ensino',
    path: '/academico/parametros/ensino/cadastro/:id?',
    parent: 'ensino',
    name: 'ensino_create',
    component: () => import('@/views/academico/parametros/ensino/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.TIPODEENSINONOVO_MENU_300900301],
    },
  },
  {
    description: 'Tipos de Ensino do Histórico',
    path: '/academico/parametros/ensinohistorico',
    name: 'ensinohistorico',
    component: () => import('@/views/academico/parametros/ensino/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.TIPOSDEENSINOPADRAO_MENUNOVO_300700810],
      ensinoHistorico: true,
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Tipo de Ensino do Histórico',
    path: '/academico/parametros/ensinohistorico/cadastro/:id?',
    parent: 'ensinohistorico',
    name: 'ensinohistorico_create',
    component: () => import('@/views/academico/parametros/ensino/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.TIPOSDEENSINOPADRAO_MENUNOVO_300700810],
      ensinoHistorico: true,
    },
  },
];
